import React, { useState } from 'react';
import axios from 'axios';
import praiaImage from '../images/praia.png';
import bonecoDeNeveImage from '../images/bonecodeneve.png';
import campoImage from '../images/campo.png';

const WeatherIcon = ({ temperature }) => {
  if (temperature > 25) {
    return <img src={praiaImage} alt="Praia" />;
  } else if (temperature >= 18 && temperature <= 25) {
    return <img src={campoImage} alt="Campo" />;
  } else {
    return <img src={bonecoDeNeveImage} alt="Boneco de Neve" />;
  }
};

const Weather = () => {
  const [weatherData, setWeatherData] = useState(null);
  const [location, setLocation] = useState('');

  const fetchWeatherData = async () => {
    try {
      const response = await axios.get(
        `https://api.openweathermap.org/data/2.5/weather?q=${location}&appid=1b0191efd266090256dc7eb66572b598&units=metric`
      );
      setWeatherData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    fetchWeatherData();
  };

  if (!weatherData) {
    return (
      <div className='formulario'>
        <form onSubmit={handleSubmit}>
          <label>
            Local:
            <input type="text" placeholder="Digite a cidade..." value={location} onChange={handleLocationChange} />
          </label>
          <button type="submit">Enviar</button>
        </form>
      </div>
    );
  }

  return (
    <div className='info'>
      <h2>Clima em <span>{weatherData.name}</span></h2>
      <WeatherIcon temperature={weatherData.main.temp} />
      <p>Temperatura: {weatherData.main.temp}°C</p>
      <p>Temperatura mínima: {weatherData.main.temp_min}°C</p>
      <p>Temperatura máxima: {weatherData.main.temp_max}°C</p>
      <p>Sensação térmica: {weatherData.main.feels_like}°C</p>
      <p>Umidade: {weatherData.main.humidity}%</p>
      <p>Descrição: {weatherData.weather[0].description}</p>
    </div>
  );
};

export default Weather;
